export default __webpack_public_path__ + "static/media/postulant.f5a6a36c.svg";